













import Vue from 'vue'

export default Vue.extend({
  name: 'Elements',

  props: {
    mainData: {
      required: true
    },
    background: {
      type: String,
      required: false,
      default: 'transparent'
    },
    isThemeHeaderGreen: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    resolveStyles (): string {
      const breakpoint = this.$vuetify.breakpoint.width >= 650
      const background = 'background-color: ' +
        (this.isThemeHeaderGreen
          ? (breakpoint ? 'var(--app-default)' : 'var(--v-primary-base) !important')
          : 'none')
      const textColor = 'color: ' +
        (this.$vuetify.theme.dark ? '#E5E9EC' : this.isThemeHeaderGreen
          ? (breakpoint ? '' : 'white !important')
          : '')
      return background + ';' + textColor
    },
    resolveClasses (): string {
      return (this.isThemeHeaderGreen && !this.isDesktop) ? 'el--background' : ''
    }
  }
})
